module.exports = __webpack_public_path__ + "static/media/default.964e031f.jpeg";